import React, { createContext, ReactNode, useContext, useMemo, useState } from "react";
import ChatImagePreview from "./chat-image-preview";

type ChatMetadata = {
  selectedImageUrl?: string;
};

const ChatMetadataContext = createContext<{ chatMetadata: ChatMetadata | undefined, setChatMetadata: (chatMetadata: ChatMetadata | undefined) => void }>({ chatMetadata: undefined, setChatMetadata: () => {} });

export function useChatMetadata() {
  const context = useContext(ChatMetadataContext);
  if (!context) {
    throw new Error("useChatMetadata must be used within a ChatMetadataProvider");
  }
  return context;
}

export function useSetChatMetadata() {
  const { setChatMetadata } = useChatMetadata();
  return setChatMetadata;
}

function ChatMetadataProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [chatMetadata, setChatMetadata] = useState<ChatMetadata | undefined>(undefined);

  console.log({chatMetadata})

  return (
    <ChatMetadataContext.Provider value={useMemo(() => ({ chatMetadata, setChatMetadata }), [chatMetadata])}>
      {children}
      <ChatImagePreview/>
    </ChatMetadataContext.Provider>
  );
}

export default ChatMetadataProvider;
